import jwt_decode from 'jwt-decode';
export default {
    name: "sendBillSealManage",
	mounted: function () {
		this.init();
	},
    data() {
        return {
            searchForm: {
                sendCompanyName: null,
                rcAuditStatus: null,
                sendAuditState: null,
                applyTime:null,
				sendAuditTime:null,
				recFristAuditTime:null,
				recFinalAuditTime:null,
                scSignatureConfirmResult:null,
                pageIndex: 1,
                pageSize: 50
            },
            tableData: [],
            selected: [],
            total: 0
        }
    },
    methods: {
		init(){
            let conditionParam = this.$routerUtil.getParam();
            if(conditionParam && conditionParam.searchForm){
                conditionParam = conditionParam.searchForm;
            }
			console.log(conditionParam);
			this.$routerUtil.clearParam();
			if(conditionParam){
                this.$nextTick(() => {
                    this.searchForm = conditionParam;
                    this.doSearch();
                });
			}
		},
        handleSizeChange(val){
            this.searchForm.pageSize = val;
            this.doSearch();
        },
        handleCurrentChange(val){
            this.searchForm.page = val;
            this.doSearch();
        },
		rowClick(row){
			this.$refs.table.toggleRowSelection(row);
		},
        handleSelectionChange(val) {
            this.selected = val;
        },
        doReset(){
			this.searchForm.sendCompanyName=null;
			this.searchForm.rcAuditStatus=null;
            this.searchForm.sendAuditState=null;
            this.searchForm.applyTime=null;
            this.searchForm.sendAuditTime=null;
            this.searchForm.recFristAuditTime=null;
            this.searchForm.recFinalAuditTime=null;
            this.searchForm.scSignatureConfirmResult=null;
		},
        doSearch() {
            const param = {};
            param.pageIndex = this.searchForm.pageIndex;
            param.pageSize = this.searchForm.pageSize;
            param.receiveCompanyName= this.searchForm.recCompany;
			param.rcAuditStatus = this.searchForm.rcAuditStatus;
			param.scAuditStatus = this.searchForm.sendAuditState;
            // 查询未签章数据 2021-02-01 打开注释
            param.signSignatureConfirmResult = 1;
            // 2021-02-01 追加
            param.scSignatureConfirmResult = this.searchForm.scSignatureConfirmResult;
            // // 三方审核通过
            // param.scAuditStatus = 1;
            // param.rcAuditStatus = 3;
            // param.signatureAuditStatus = 1;
            if(this.searchForm.applyTime){
				param.createTimeBeginTime = this.searchForm.applyTime[0];
				param.createTimeEndTime = this.searchForm.applyTime[1];
			}
			if(this.searchForm.sendAuditTime){
				param.scfAuditUserDayBeginTime = this.searchForm.sendAuditTime[0];
				param.scfAuditUserDayEndTime = this.searchForm.sendAuditTime[1];
			}
			if(this.searchForm.recFristAuditTime){
				param.rcfAuditUserDayBeginTime = this.searchForm.recFristAuditTime[0];
				param.rcfAuditUserDayEndTime = this.searchForm.recFristAuditTime[1];
			}
			if(this.searchForm.recFinalAuditTime){
				param.rcsAuditUserDayBeginTime = this.searchForm.recFinalAuditTime[0];
				param.rcsAuditUserDayEndTime = this.searchForm.recFinalAuditTime[1];
			}
            this.loading = true;
            this.$axios.get('/api/receipts/recordManage', {params: param}).then(response => {
                console.log(response.data);
                if (response.data.status === '1') {
                    this.tableData = response.data.resultData.rows;
                    this.total = response.data.resultData.total;
                }else{
                    this.$message({
                        message: this.$t('common.message.operateFail'),
                        type: 'error',
                        center: true
                    });
                }
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            });
        },
		doSignatureConfirm(){
            const row = this.getSelectedRow();
            const token = jwt_decode(sessionStorage.getItem('token'));
			// 当前登录人公司id
            const customerCompanyId = token.customerCompanyId;
			if (row) {
				const conditionData = new Object();
				conditionData.searchForm = this.searchForm;
                conditionData.row = row;
                // 收单公司id
				// 您已经完成签章确认操作，不需重复操作
				// if (customerCompanyId === row.receiveCompanyId && (row.rcSignatureConfirmResult === 1 || row.rcSignatureConfirmResult === 0)) {
				// 	this.$message({
				// 		message: this.$t('s_billSealManage.message.isAlreadySealConfirm'),
				// 		type: 'warning',
                //         center: true
				// 	});
				// 	return ;
				// }
				// 发单公司id
				// 您已经完成签章确认操作，不需重复操作
				if (customerCompanyId === row.sendCompanyId && (row.scSignatureConfirmResult === 1 || row.scSignatureConfirmResult === 0)) {
					this.$message({
						message: this.$t('s_billSealManage.message.isAlreadySealConfirm'),
						type: 'warning',
                        center: true
					});
					return ;
				}
				// 签章公司id
				// 您已经完成签章确认操作，不需重复操作
				if (customerCompanyId === row.signatureCompanyId && (row.signSignatureConfirmResult === 1 || row.signSignatureConfirmResult === 0)) {
					this.$message({
						message: this.$t('s_billSealManage.message.isAlreadySealConfirm'),
						type: 'warning',
                        center: true
					});
					return ;
                }
                if (row.signSignatureConfirmResult !== 1) {
					this.$message({
						message: this.$t('s_billSealManage.message.isNotSign'),
						type: 'warning',
                        center: true
					});
					return ;
				}
				this.$router.push('BillSealConfirm');
				this.$routerUtil.setParam(conditionData);
			}
		},
        // doSignature(){
        //     const row = this.getSelectedRow();
		// 	if (row) {
		// 		const conditionData = new Object();
		// 		conditionData.searchForm = this.searchForm;
		// 		conditionData.row = row;
		// 		this.$router.push('BillSeal');
		// 		this.$routerUtil.setParam(conditionData);
		// 	}
        // },
        getSelectedRow(){
            if (this.selected.length > 1) {
                this.$message({
                    message: this.$t('common.message.onlyOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            if (this.selected.length < 1) {
                this.$message({
                    message: this.$t('common.message.atLastOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            return this.selected[0];
        }
    }
}
